import BaseSlider from './BaseSlider';

export default class Slider extends BaseSlider {
  constructor(sliderEl) {
    super();
    this.sliderEl = sliderEl;
    this.sliderInstance = null;
    this.config = null;
  }

  init() {
    const sliderInstance = this.getSplideInstance(this.sliderEl);

    sliderInstance.mount();
    this.sliderInstance = sliderInstance;
    super.init({ sliderInstance, sliderEl: this.sliderEl });
  }
}
